import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const setNotification = createAsyncThunk("notifications/setNotification", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/set-notification", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateContentNudgeSent = createAsyncThunk("notifications/updateContentNudgeSent", async (id, thunkAPI) => {
  try {
    const response = await API("update-content-nudge", {method: "POST", body: {id}});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
